/**
 * @file AnnotationGroupContainer.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Mar 21, 2022 11:00
 */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import AnnotationGroupForm from './AnnotationGroupForm';

import {
    objectExists,
    stringExists
} from 'src/@common/utilities';

import {
    annotationDeleteRequest,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

function AnnotationGroupContainer(props) {
    const {
        title,
        canDeleteAnnotation,
    } = props;

    const dispatch = useDispatch();

    // start: redux state --------------------------
    const documentAnnotatorDbState = useSelector((state) => {
        return state.documentAnnotatorDb;
    });

    const {
        annotationGroup,
    } = documentAnnotatorDbState;
    // end: redux state -----------------------------

    const [curatedText, setCuratedText] = useState('');

    useEffect(() => {
        if (objectExists(annotationGroup)) {
            if (stringExists(annotationGroup.curatedText)) {
                setCuratedText(annotationGroup.curatedText);
            } else {
                setCuratedText('');
            }
        }
    }, [annotationGroup]);

    const handleDeleteAnnotation = (annotationId) => {
        dispatch(annotationDeleteRequest(annotationGroup, annotationId));
    };

    return (
        <AnnotationGroupForm
            annotationGroup={annotationGroup}
            curatedText={curatedText}
            title={title}
            canDeleteAnnotation={canDeleteAnnotation}
            handleDeleteAnnotation={handleDeleteAnnotation}
        />
    )

}

AnnotationGroupContainer.propTypes = {
    title: PropTypes.string,
    canDeleteAnnotation: PropTypes.bool,
};

export default AnnotationGroupContainer;
